/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */
import { all, takeLatest } from "redux-saga/effects";
import {
  watcherLoginWithFacebookRequest,
  watcherLoginRequest,
  watcherSignUpAccountRequest,
  watcherLogoutAccount,
  watcherClearAccessToken,
  watcherSetProfileStatus,
  watcherUpdateProfileStatus,
  watcherClearProfileStatus,
  watcherUpdateAccessToken,
  watcherUpdateUserName,
  watcherClearUserName,
  watcherPostResetPasswordWithEmail,
  watcherPostResetPasswordWithPhone,
  watcherPostForgetPassword,
  watcherLinkSocialNetworkRequest
} from "./auth";
import {
  LOGIN_WITH_FACEBOOK_REQUEST,
  LOGIN_WITH_FACEBOOK_SUCCESS,
  LOGIN_ACCOUNT_REQUEST,
  LOGIN_ACCOUNT_SUCCESS,
  SIGN_UP_ACCOUNT_REQUEST,
  LOGOUT_ACCOUNT_REQUEST,
  CLEAR_ACCESS_TOKEN,
  UPDATE_ACCESS_TOKEN,
  UPDATE_USER_NAME,
  CLEAR_USER_NAME,
  POST_FORGET_PASSWORD_REQUEST,
  POST_RESET_PASSWORD_WITH_PHONE_REQUEST,
  POST_RESET_PASSWORD_WITH_EMAIL_REQUEST,
  LOGOUT_ACCOUNT_SUCCESS,
  SET_PROFILE_STATUS,
  LINK_SOCIAL_NETWORK_REQUEST
} from "../actions/auth";
import {
  REQUEST_PHONE_VERIFICATION_CODE_REQUEST,
  VERIFY_PHONE_VERIFICATION_CODE_REQUEST
} from "../actions/verification";
import {
  watcherRequestPhoneVerificationCode,
  watcherVerifyPhoneVerificationCode
} from "./verification";
import {
  GET_STALL_DETAIL_REQUEST,
  GET_STALL_LIST_REQUEST
} from "../actions/stall";
import { watcherGetStallDetailRequest, watcherGetStallList } from "./stall";
import { GET_CATEGORY_LIST_REQUEST } from "../actions/category";
import { watcherGetCategoryList } from "./category";
import {
  watcherFavouriteFoodRequest,
  watcherGetFoodDetailItemRequest,
  watcherGetFoodReviewListRequest,
  watcherGetStallFoodDataRequest,
  watcherUnFavouriteFoodRequest
} from "./food";
import {
  FAVOURITE_FOOD_REQUEST,
  GET_FOOD_DETAIL_ITEM_REQUEST,
  GET_FOOD_REVIEW_LIST_REQUEST,
  GET_STALL_FOOD_DATA_REQUEST,
  UNFAVOURITE_FOOD_REQUEST
} from "../actions/food";
import { watcherGetFavouriteFoodListRequest } from "./favourite";
import { GET_FAVOURITE_FOOD_LIST_REQUEST } from "../actions/favourite";
import { GET_ME_DATA_REQUEST } from "../actions/me";
import { watcherGetMeDataRequest } from "./me";
import {
  watcherCreateNewTopUpRequest,
  watcherGetMyWalletDetailRequest,
  watcherGetWalletTransactionListRequest,
  watcherRefreshWalletDetailCacheRequest,
  watcherUpdateTopUpPaymentRequest
} from "./wallet";
import {
  CREATE_NEW_TOP_UP_REQUEST,
  GET_MY_WALLET_DETAIL_REQUEST,
  GET_WALLET_TRANSACTION_LIST_REQUEST,
  REFRESH_WALLET_DETAIL_CACHE_REQUEST,
  UPDATE_TOP_UP_PAYMENT_REQUEST
} from "../actions/wallet";
import { UPDATE_LANGUAGE } from "../actions/global";
import { watcherUpdateLanguage } from "./global";
import { POST_SUBMIT_REVIEW_REQUEST } from "../actions/review";
import { watcherPostSubmitReviewRequest } from "./review";
import {
  ADD_USER_CART_FOOD_REQUEST,
  APPLY_USER_CART_POINT_REQUEST,
  APPLY_USER_CART_WALLET_REQUEST,
  CANCEL_USER_ORDER_REQUEST,
  CHECKOUT_USER_CART_REQUEST,
  CLEAR_ORDER_INDICATOR,
  DELETE_USER_CART_ITEM_REQUEST,
  EDIT_USER_CART_FOOD_REQUEST,
  GET_USER_CART_ITEM_REQUEST,
  GET_USER_ORDER_DETAIL_REQUEST,
  GET_USER_ORDER_LIST_REQUEST,
  GET_USER_QUEUE_COMPLETE_ITEM_REQUEST,
  GET_USER_QUEUE_LIST_REQUEST,
  GET_USER_QUEUE_READY_ITEM_REQUEST,
  POST_USER_ORDER_PAYMENT_REQUEST,
  SET_ORDER_INDICATOR,
  UPDATE_ORDER_SUMMARY_TABLE_REQUEST,
  UPDATE_USER_CART_FOOD_DELIVERY_REQUEST,
  UPDATE_USER_ORDER_PAYMENT_REQUEST,
  UPDATE_USER_ORDER_TABLE_REQUEST
} from "../actions/user";
import {
  watcherAddUserCartFoodRequest,
  watcherApplyUserCartPointRequest,
  watcherApplyUserCartWalletRequest,
  watcherCancelUserOrderRequest,
  watcherCheckoutUserCartRequest,
  watcherClearOrderIndicator,
  watcherDeleteUserCartItemRequest,
  watcherEditUserCartFoodRequest,
  watcherGetUserCartItemRequest,
  watcherGetUserOrderDetailRequest,
  watcherGetUserOrderListRequest,
  watcherGetUserQueueCompleteItemRequest,
  watcherGetUserQueueItemRequest,
  watcherGetUserQueueReadyItemRequest,
  watcherPostUserOrderPaymentRequest,
  watcherSetOrderIndicator,
  watcherUpdateUserCartFoodDeliveryRequest,
  watcherUpdateUserOrderPaymentRequest,
  watcherUpdateUserOrderTableRequest,
  watcherUpdateOrderSummaryTable
} from "./user";
import {
  UPDATE_PROFILE_DATA_REQUEST,
  GET_PROFILE_BASIC_REQUEST,
  UPDATE_PROFILE_BASIC_REQUEST
} from "../actions/profile";
import {
  watcherUpdateProfileDataRequest,
  watcherGetProfileBasicRequest,
  watcherUpdateProfileBasicRequest
} from "./profile";
import {
  POST_NEW_SEARCH_REQUEST,
  PUT_SEARCH_QUERY_TOKEN_REQUEST
} from "../actions/search";
import {
  watcherPostNewSearchRequest,
  watcherPutSearchQueryTokenRequest
} from "./search";
import { GET_PAGE_TNC_DATA_REQUEST } from "../actions/page";
import { watcherGetPageTncDataRequest } from "./page";
import { watcherGetPointTransactionListRequest } from "./point";
import { GET_POINT_TRANSACTION_LIST_REQUEST } from "../actions/point";
import {
  UPDATE_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_REQUEST,
  UPDATE_NOTIFICATION_ITEMS_ID_REQUEST
} from "../actions/notification";
import {
  watcherGetNotificationRequest,
  watcherUpdateNotificationRequest,
  watcherUpdateNotificationItemsIDRequest
} from "./notification";
import {
  GET_DELIVERY_ENABLED_REQUEST,
  GET_COMMON_CONFIG_REQUEST,
  GET_OCCUPATION_REQUEST
} from "../actions/common";
import { watcherGetDeliveryEnabledRequest } from "./common";
import { watcherGetCommonConfigRequest } from "./common";
import { watcherGetOccupationRequest } from "./common";
import { watcherGetBannerRequest, watcherDismissBannerRequest } from "./banner";
import {GET_BANNER_REQUEST, DISMISS_BANNER_REQUEST} from "../actions/banner";

function* rootSaga() {
  yield all([
    //Auth Saga
    yield takeLatest(
      LOGIN_WITH_FACEBOOK_REQUEST,
      watcherLoginWithFacebookRequest
    ),
    yield takeLatest(LOGIN_WITH_FACEBOOK_SUCCESS, watcherSetProfileStatus),
    yield takeLatest(LOGIN_ACCOUNT_REQUEST, watcherLoginRequest),
    yield takeLatest(LOGIN_ACCOUNT_SUCCESS, watcherSetProfileStatus),
    yield takeLatest(SIGN_UP_ACCOUNT_REQUEST, watcherSignUpAccountRequest),
    yield takeLatest(LOGOUT_ACCOUNT_REQUEST, watcherLogoutAccount),
    yield takeLatest(LOGOUT_ACCOUNT_SUCCESS, watcherClearProfileStatus),
    yield takeLatest(CLEAR_ACCESS_TOKEN, watcherClearAccessToken),
    yield takeLatest(UPDATE_ACCESS_TOKEN, watcherUpdateAccessToken),
    yield takeLatest(CLEAR_USER_NAME, watcherClearUserName),
    yield takeLatest(UPDATE_USER_NAME, watcherUpdateUserName),
    yield takeLatest(POST_FORGET_PASSWORD_REQUEST, watcherPostForgetPassword),
    yield takeLatest(
      LINK_SOCIAL_NETWORK_REQUEST,
      watcherLinkSocialNetworkRequest
    ),
    yield takeLatest(
      POST_RESET_PASSWORD_WITH_PHONE_REQUEST,
      watcherPostResetPasswordWithPhone
    ),
    yield takeLatest(
      POST_RESET_PASSWORD_WITH_EMAIL_REQUEST,
      watcherPostResetPasswordWithEmail
    ),
    //Verification Saga
    yield takeLatest(
      REQUEST_PHONE_VERIFICATION_CODE_REQUEST,
      watcherRequestPhoneVerificationCode
    ),
    yield takeLatest(
      VERIFY_PHONE_VERIFICATION_CODE_REQUEST,
      watcherVerifyPhoneVerificationCode
    ),
    //Stall Saga
    yield takeLatest(GET_STALL_LIST_REQUEST, watcherGetStallList),
    yield takeLatest(GET_STALL_DETAIL_REQUEST, watcherGetStallDetailRequest),
    //Category Saga
    yield takeLatest(GET_CATEGORY_LIST_REQUEST, watcherGetCategoryList),
    //Food Saga
    yield takeLatest(
      GET_STALL_FOOD_DATA_REQUEST,
      watcherGetStallFoodDataRequest
    ),
    yield takeLatest(
      GET_FOOD_DETAIL_ITEM_REQUEST,
      watcherGetFoodDetailItemRequest
    ),
    yield takeLatest(
      GET_FOOD_REVIEW_LIST_REQUEST,
      watcherGetFoodReviewListRequest
    ),
    yield takeLatest(FAVOURITE_FOOD_REQUEST, watcherFavouriteFoodRequest),
    yield takeLatest(UNFAVOURITE_FOOD_REQUEST, watcherUnFavouriteFoodRequest),
    //Favourite Saga
    yield takeLatest(
      GET_FAVOURITE_FOOD_LIST_REQUEST,
      watcherGetFavouriteFoodListRequest
    ),
    //Review Saga
    yield takeLatest(
      POST_SUBMIT_REVIEW_REQUEST,
      watcherPostSubmitReviewRequest
    ),
    //Me Saga
    yield takeLatest(GET_ME_DATA_REQUEST, watcherGetMeDataRequest),
    //Wallet Saga
    yield takeLatest(CREATE_NEW_TOP_UP_REQUEST, watcherCreateNewTopUpRequest),
    yield takeLatest(
      GET_MY_WALLET_DETAIL_REQUEST,
      watcherGetMyWalletDetailRequest
    ),
    yield takeLatest(
      REFRESH_WALLET_DETAIL_CACHE_REQUEST,
      watcherRefreshWalletDetailCacheRequest
    ),
    yield takeLatest(
      UPDATE_TOP_UP_PAYMENT_REQUEST,
      watcherUpdateTopUpPaymentRequest
    ),
    yield takeLatest(
      GET_WALLET_TRANSACTION_LIST_REQUEST,
      watcherGetWalletTransactionListRequest
    ),
    yield takeLatest(UPDATE_LANGUAGE, watcherUpdateLanguage),
    //User Saga
    yield takeLatest(GET_USER_CART_ITEM_REQUEST, watcherGetUserCartItemRequest),
    yield takeLatest(ADD_USER_CART_FOOD_REQUEST, watcherAddUserCartFoodRequest),
    yield takeLatest(
      DELETE_USER_CART_ITEM_REQUEST,
      watcherDeleteUserCartItemRequest
    ),
    yield takeLatest(
      APPLY_USER_CART_WALLET_REQUEST,
      watcherApplyUserCartWalletRequest
    ),
    yield takeLatest(
      APPLY_USER_CART_POINT_REQUEST,
      watcherApplyUserCartPointRequest
    ),
    yield takeLatest(
      EDIT_USER_CART_FOOD_REQUEST,
      watcherEditUserCartFoodRequest
    ),
    yield takeLatest(
      UPDATE_USER_CART_FOOD_DELIVERY_REQUEST,
      watcherUpdateUserCartFoodDeliveryRequest
    ),
    yield takeLatest(
      CHECKOUT_USER_CART_REQUEST,
      watcherCheckoutUserCartRequest
    ),
    yield takeLatest(
      GET_USER_ORDER_DETAIL_REQUEST,
      watcherGetUserOrderDetailRequest
    ),
    yield takeLatest(
      GET_USER_ORDER_LIST_REQUEST,
      watcherGetUserOrderListRequest
    ),
    yield takeLatest(SET_ORDER_INDICATOR, watcherSetOrderIndicator),
    yield takeLatest(CLEAR_ORDER_INDICATOR, watcherClearOrderIndicator),
    yield takeLatest(CANCEL_USER_ORDER_REQUEST, watcherCancelUserOrderRequest),
    yield takeLatest(
      UPDATE_USER_ORDER_TABLE_REQUEST,
      watcherUpdateUserOrderTableRequest
    ),
    yield takeLatest(
      UPDATE_USER_ORDER_PAYMENT_REQUEST,
      watcherUpdateUserOrderPaymentRequest
    ),
    yield takeLatest(
      GET_USER_QUEUE_LIST_REQUEST,
      watcherGetUserQueueItemRequest
    ),
    yield takeLatest(
      GET_USER_QUEUE_READY_ITEM_REQUEST,
      watcherGetUserQueueReadyItemRequest
    ),
    yield takeLatest(
      GET_USER_QUEUE_COMPLETE_ITEM_REQUEST,
      watcherGetUserQueueCompleteItemRequest
    ),
    yield takeLatest(
      POST_USER_ORDER_PAYMENT_REQUEST,
      watcherPostUserOrderPaymentRequest
    ),
    yield takeLatest(
      UPDATE_PROFILE_DATA_REQUEST,
      watcherUpdateProfileDataRequest
    ),
    yield takeLatest(GET_PROFILE_BASIC_REQUEST, watcherGetProfileBasicRequest),
    yield takeLatest(
      UPDATE_PROFILE_BASIC_REQUEST,
      watcherUpdateProfileBasicRequest
    ),
    yield takeLatest(POST_NEW_SEARCH_REQUEST, watcherPostNewSearchRequest),
    yield takeLatest(
      PUT_SEARCH_QUERY_TOKEN_REQUEST,
      watcherPutSearchQueryTokenRequest
    ),
    yield takeLatest(GET_PAGE_TNC_DATA_REQUEST, watcherGetPageTncDataRequest),
    yield takeLatest(
      GET_POINT_TRANSACTION_LIST_REQUEST,
      watcherGetPointTransactionListRequest
    ),
    // Notification
    yield takeLatest(GET_NOTIFICATION_REQUEST, watcherGetNotificationRequest),
    yield takeLatest(
      UPDATE_NOTIFICATION_REQUEST,
      watcherUpdateNotificationRequest
    ),
    yield takeLatest(
      UPDATE_NOTIFICATION_ITEMS_ID_REQUEST,
      watcherUpdateNotificationItemsIDRequest
    ),
    yield takeLatest(
      UPDATE_ORDER_SUMMARY_TABLE_REQUEST,
      watcherUpdateOrderSummaryTable
    ),
    //common
    yield takeLatest(
      GET_DELIVERY_ENABLED_REQUEST,
      watcherGetDeliveryEnabledRequest
    ),
    yield takeLatest(GET_COMMON_CONFIG_REQUEST, watcherGetCommonConfigRequest),
    yield takeLatest(GET_OCCUPATION_REQUEST, watcherGetOccupationRequest),
    yield takeLatest(SET_PROFILE_STATUS, watcherUpdateProfileStatus),
    //banner
    yield takeLatest(GET_BANNER_REQUEST, watcherGetBannerRequest),
    yield takeLatest(DISMISS_BANNER_REQUEST, watcherDismissBannerRequest)
  ]);
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/sagas/index.js